'use client'

import type { ClientEvents } from '@mentora/data-access/analytics-events'
import posthog from 'posthog-js'
import { useCallback } from 'react'

/** Typed capture: event names and properties come from the shared catalogue. */
export function useAnalytics() {
  const track = useCallback(<E extends keyof ClientEvents>(event: E, properties: ClientEvents[E]) => {
    // An opted-out or unbooted posthog drops the call itself.
    posthog.capture(event, properties)
  }, [])
  return { track }
}
